import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NotificationMessageWrapperComponent } from './notification-message-wrapper.component';

@NgModule({
  declarations: [
    NotificationMessageWrapperComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NotificationMessageWrapperComponent
  ]
})
export class NotificationWrapperTagModule { }
